import React, { Component } from 'react';
import './ShoppingCart.scss';
import '../../css/icons.scss'
import parameterService from '../../services/parameterService';
import languageService from '../../services/languageService';

class ShoppingCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId: parameterService.data.orderId,
            amount: parameterService.data.amount,
            merchantLogo: parameterService.data.merchantLogo,
            shoppingCart: parameterService.data.shoppingCart,
            userData: parameterService.data.userData,
            shippingDetails: parameterService.data.shippingDetails,
            billingDetails: parameterService.data.billingDetails,
            freeTextHeader: parameterService.data.freeTextHeader,
            freeTextValue: parameterService.data.freeTextValue
        };
    }

    render() {
        return (
            <div className="ShoppingCart">
                <div className="amount-container row">
                    {this.state.amount && <div className="col-12">
                        <p className="amount">
                            <span className="amount-description">{languageService.texts.totalAmount}</span>
                            <span className="amount-price">{this.state.amount}</span>
                        </p>
                    </div>}
                </div>
                <div className="items-container row align-items-start scroll">
                    <div className="dynamic-field-toggle d-sm-none">
                        <a
                            href="#collapseDynamicFields"
                            className="btn btn-link"
                            data-toggle="collapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseDynamicFields">
                            {languageService.texts.moreDetails}
                            <i className="arrow-svg align-middle"></i>
                        </a>
                    </div>
                    <div className="order-container col-md-12">
                        <div className="row">
                            <div className="col-12 my-4 collapse" id="collapseDynamicFields">
                                {this.state.orderId && <p className="order">
                                    <span className="order-description">{languageService.texts.yourOrder}</span>
                                    <span className="order-id">{this.state.orderId}</span>
                                </p>}
                                {this.state.shoppingCart && <div className="dynamic-field">
                                    <div className="dynamic-field-description">{languageService.texts.shoppingCart}</div>
                                    <pre className="dynamic-field-content">{this.state.shoppingCart}</pre>
                                </div>}
                                {this.state.userData && <div className="dynamic-field">
                                    <div className="dynamic-field-description">{languageService.texts.customerDetails}</div>
                                    <pre className="dynamic-field-content">{this.state.userData}</pre>
                                </div>}
                                {this.state.shippingDetails && <div className="dynamic-field">
                                    <div className="dynamic-field-description">{languageService.texts.shippingTo}</div>
                                    <pre className="dynamic-field-content">{this.state.shippingDetails}</pre>
                                </div>}
                                {this.state.billingDetails && <div className="dynamic-field">
                                    <div className="dynamic-field-description">{languageService.texts.billingDetails}</div>
                                    <pre className="dynamic-field-content">{this.state.billingDetails}</pre>
                                </div>}
                                {(this.state.freeTextHeader || this.state.freeTextValue) && <div className="dynamic-field">
                                    {this.state.freeTextHeader && <div className="dynamic-field-description text-uppercase">{this.state.freeTextHeader}</div>}
                                    {this.state.freeTextValue && <pre className="dynamic-field-content">{this.state.freeTextValue}</pre>}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ShoppingCart;



// WEBPACK FOOTER //
// ./src/components/ShoppingCart/ShoppingCart.js